import { z } from 'zod';
/** Claude models the workflow tab offers (doc 38); Sonnet is the default — it is the user's own API bill. */
export const CHAT_MODELS = ['claude-sonnet-5', 'claude-opus-5-5'];
export const ChatModelSchema = z.enum(CHAT_MODELS);
export const ChatStatusSchema = z.enum(['idle', 'running', 'failed']);
export const ChatSchema = z.object({
    id: z.string(),
    title: z.string(),
    machineId: z.string().nullable(),
    model: ChatModelSchema,
    status: ChatStatusSchema,
    error: z.string().nullable(),
    recipeId: z.string().nullable(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
/** What the page shows: said text, pictures, and each tool Claude used with its answer. */
export const ChatItemSchema = z.discriminatedUnion('kind', [
    z.object({ kind: z.literal('text'), role: z.enum(['user', 'assistant']), text: z.string() }),
    z.object({ kind: z.literal('image'), role: z.enum(['user', 'assistant']), src: z.string() }),
    z.object({
        kind: z.literal('tool'), name: z.string(), input: z.string(),
        output: z.string().nullable(), isError: z.boolean(), image: z.string().nullable(),
    }),
]);
export const ChatsResponseSchema = z.object({ chats: z.array(ChatSchema) });
export const ChatResponseSchema = z.object({ chat: ChatSchema });
export const ChatDetailResponseSchema = z.object({ chat: ChatSchema, items: z.array(ChatItemSchema) });
export const CreateChatRequestSchema = z.object({
    machineId: z.string().min(1).max(64),
    model: ChatModelSchema.default('claude-sonnet-5'),
});
/** Pictures go to the machine first (doc 33); the message names them. */
export const SendChatMessageRequestSchema = z.object({
    text: z.string().trim().min(1, 'Write what Claude should do').max(8000),
    images: z.array(z.string().min(1).max(300)).max(8).default([]),
});
//# sourceMappingURL=chats.js.map